import React from 'react'
import PropTypes from 'prop-types'
import GridContainer from '@naturacosmeticos/natds-web/dist/Components/GridContainer'
import Container from '@material-ui/core/Container'
import GridItem from '@naturacosmeticos/natds-web/dist/Components/GridItem'

const EmptyMenu = ({ logoImage }) => {
  return (
    <GridContainer
      alignItems="center"
      container
      component={Container}
      direction="row"
      itemScope
      justify="center"
    >
      <GridItem>{logoImage}</GridItem>
    </GridContainer>
  )
}

EmptyMenu.propTypes = {
  logoImage: PropTypes.node.isRequired
}

export default EmptyMenu
